export function getStorage<T>(
    key: string,
    type: "local" | "session" = "local"
) {
    const storage =
        type === "local" ? window.localStorage : window.sessionStorage;

    const item = storage.getItem(key);
    return !item || item === "undefined" || item === "null"
        ? undefined
        : (JSON.parse(item) as T);
}

export function setStorage<T>(
    key: string,
    value: T,
    type: "local" | "session" = "local"
) {
    const storage =
        type === "local" ? window.localStorage : window.sessionStorage;

    if (value !== undefined && value !== null)
        storage.setItem(key, JSON.stringify(value));
}

export function updateStorage<T>(
    key: string,
    updateFunc: (oldValue: T | undefined) => T | undefined,
    type: "local" | "session" = "local"
) {
    const newValue = updateFunc(getStorage(key, type));

    if (newValue) setStorage(key, newValue, type);
    else removeStorage(key, type);
}

export function removeStorage(
    key: string,
    type: "local" | "session" = "local"
) {
    const storage =
        type === "local" ? window.localStorage : window.sessionStorage;

    storage.removeItem(key);
}

export function clearStorage(type: "local" | "session") {
    const storage =
        type === "local" ? window.localStorage : window.sessionStorage;

    storage.clear();
}

export default class StorageManagerCapys<T> {
    key: string;
    type: "local" | "session";

    constructor(key: string, type: "local" | "session" = "local") {
        this.key = key;
        this.type = type;
    }

    public set(value: T) {
        setStorage(this.key, value, this.type);
    }
    public get() {
        return getStorage<T>(this.key, this.type);
    }
    public remove() {
        removeStorage(this.key, this.type);
    }
    public update(updateFunc: (newValue: T | undefined) => T | undefined) {
        updateStorage(this.key, updateFunc, this.type);
    }
}
